/**
 * 필요한 환경변수 목록 (PUBLIC_ 접두사 사용)
 */
const REQUIRED_ENV_VARS = [
  'PUBLIC_API_URL',
  'PUBLIC_OPENAPI_URL',
  'PUBLIC_AUTH_STORAGE_KEY',
  'PUBLIC_FEEDBACK_API_URL',
];

/**
 * 애플리케이션 시작 시 환경변수 검증
 * 필수 환경변수가 모두 설정되어 있는지 확인합니다.
 */
export function validateEnv(): void {
  // // 누락된 환경변수 목록
  // const missing = REQUIRED_ENV_VARS.filter(key =>
  //   !import.meta.env[key] && import.meta.env[key] !== '');
  // if (missing.length > 0) {
  //   console.error(`누락된 환경변수: ${missing.join(', ')}`);
  //   throw new Error('필수 환경변수가 설정되지 않았습니다. .env 파일을 확인해주세요.');
  // }
}
